import { createContext } from 'react';

import { defaultWebSocketState } from '@/inpatient-dashboard/services/websocket';

// The initial websocket context
const websocketContext = createContext(defaultWebSocketState);

export default websocketContext;
